<template>
  <div ref="company">
    <div
      v-click-outside="hide"
      class="position-relative"
    >
      <v-search
        :research="state === 'research' || state === 'final'"
      />
      <v-list
        v-if="state === 'research' || state === 'final'"
        @company-selected="setState('search')"
      />
      <v-selector
        @remove-company="setState('research')"
      />
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';

import { ui } from '@/mixins';

import Selector from './CompanySelector.vue';
import SearchBar from './AutoComplete.vue';
import CompanyDisplayList from './CompanyDisplayList.vue';

export default {
  components: {
    'v-selector': Selector,
    'v-search': SearchBar,
    'v-list': CompanyDisplayList,
  },
  directives: {
    ClickOutside,
  },
  mixins: [ui],
  data() {
    return {
      state: 'research',
    };
  },
  computed: {
    ...mapGetters('ui', ['focusScreen']),
  },
  methods: {
    hide() {
      this.ui_focusScreen(false);
    },
    setState(state) {
      this.state = state;
    },
  },
};
</script>
